// extracted by mini-css-extract-plugin
export default {"offer":"similar-to-you--1_j3f","offer--exit-active":"similar-to-you--1jXTF","offer--exited":"similar-to-you--KCyBG"};